<template>
    <div v-if="!is_api">
        <b-tabs pills card vertical>
            <b-tab>
                <template #title>
                    <div class="fs-lg px-4 text-center">{{ __t('MAIN_QR') }}</div>
                </template>

                <div class="p-3">
                    <qr_code
                        v-if="is_load_url"
                        key="sss"
                        :url="base_url_menu"
                        :color="'#000000'"
                        :bgColor="'#ffffff'"
                        :size="250"
                    />
                </div>
            </b-tab>

            <b-tab v-for="(section, sidx) in sections" :key="sidx" :active="section.is_active">
                <template #title>
                    <div class="fs-lg px-4 text-center d-flex justify-content-between align-items-center">
                        <span class="flex-grow-1">{{ section.name }}</span>
                    </div>
                </template>

                <div class="tables">
                    <b-container class="bv-example-row">
                        <b-row>
                            <b-col sm="4" xl="4" xs="2" v-for="(table, index) in section.tables" :key="'col_' + table.id">
                                <div class="table_name">
                                    {{table.name}}
                                    <qr_code
                                        :key="'qr_' + table.id"
                                        :uniq_ref="'qr_table_' + table.id"
                                        :url="base_url + '/' + table.uniq_id"
                                        :color="'#000000'"
                                        :bgColor="'#ffffff'"
                                        :size="250"
                                    />
                                </div>
                            </b-col>
                        </b-row>
                    </b-container>
                </div>
            </b-tab>
        </b-tabs>
    </div>
</template>

<script>
import {mapGetters} from "vuex";
import qr_code from "../qr/qr_code.vue";
import TableList from "../../../../catalog/restaurants/item/tabs/tables/table_list.vue";
export default {
    name: "pwa_qr_tab",

    props : {
        location : {
            type : Object
        },

        show_sections : {
            default : true,
            type : Boolean,
        }
    },

    components : {
        TableList,
        qr_code
    },

    data() {
        return {
            is_load: false,
            is_load_url : false,
            base_url : this.generated_url,
            sections : []
        }
    },


    created() {
        if(this.show_sections) {
            this.load_tables();
        }

        this.load_url();
    },

    methods : {

        async load_url() {
            this.is_load_url = false;

            agr_api.get('/aggregators/pwa/'+ this.location.id +'/url').then(({data}) => {
                this.is_load_url = true;
                if (data.status === "operation_success") {
                    this.base_url = data.data;
                }
            })
            .catch(({response}) => {
                this.is_load_url = true;
                EventBus.$emit('show_toast', {
                    err: response.data.message,
                    type: "danger",
                    title: response.data.status
                })
            });
        },

        async load_tables() {
            this.is_load = true;
            this.sections = [];

            await api.get('/internal/v1/catalog/restaurants/' + this.location.link_id + "/sections").then(({data}) => {
                this.is_load = false;
                if (data.status === "operation_success") {
                    this.sections = data.data;
                }
            }).catch(({response}) => {
                this.is_load = false;
                EventBus.$emit('show_toast', {err: response.data.message, type: "danger", title: response.data.status,position : "b-toaster-top-left"})
            });
        }
    },


    computed : {
        ...mapGetters({
            'user'              : "user/getUser",
            'aggregator'        : "aggregator/getAggregator",
            'is_load_complete'  : "aggregator/is_load_complete"
        }),

        base_url_menu() {
            return this.base_url?.replace(/\/table(?=\/|$)/, '/menu');
        },

        generated_url() {
            return "https://" + this.user.username.replace("_","-") + ".getorder.biz/delivery/" + this.location.uniq_id;
        } ,

        is_api() {
            return this.location.provider == 'api';
        },

    },



}
</script>

<style scoped>

</style>
